/**
 * Scroll Arrows — generic show/hide-on-scroll behaviour for any horizontally
 * scrolling row with left/right arrow buttons.
 *
 * Shared by: product page color swatches (ppv2__colors-wrap) and the
 * subcategory header sub-collection row (ssc__thumbs-wrap). Any other
 * horizontal scroller can reuse it too — just follow this markup contract:
 *
 *   <div data-scroll-arrows>
 *     <button data-scroll-arrow="left">…</button>
 *     <div data-scroll-track>…scrollable content…</div>
 *     <button data-scroll-arrow="right">…</button>
 *   </div>
 *
 * Each arrow gets an "is-active" class added/removed based on whether there
 * is more content to scroll to in that direction — mirroring the existing
 * product page swatch arrow behaviour.
 */
(function () {
  const wraps = document.querySelectorAll('[data-scroll-arrows]');
  if (!wraps.length) return;

  wraps.forEach((wrap) => {
    const track = wrap.querySelector('[data-scroll-track]');
    const leftArrow = wrap.querySelector('[data-scroll-arrow="left"]');
    const rightArrow = wrap.querySelector('[data-scroll-arrow="right"]');

    if (!track || !leftArrow || !rightArrow) return;

    const updateArrows = () => {
      const scrollLeft = Math.round(track.scrollLeft);
      const maxScroll = track.scrollWidth - track.clientWidth;

      // Left arrow: show only when scrolled right
      if (scrollLeft <= 0) {
        leftArrow.classList.remove('is-active');
      } else {
        leftArrow.classList.add('is-active');
      }

      // Right arrow: hide when scrolled to end (hover handles initial show)
      if (scrollLeft >= maxScroll - 1) {
        rightArrow.classList.remove('is-active');
      } else {
        rightArrow.classList.add('is-active');
      }
    };

    const scrollStep = parseInt(wrap.getAttribute('data-scroll-step'), 10) || 200;

    leftArrow.addEventListener('click', () => {
      track.scrollBy({ left: -scrollStep, behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', () => {
      track.scrollBy({ left: scrollStep, behavior: 'smooth' });
    });

    updateArrows();
    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
  });
})();
